import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Navbar,Nav} from 'react-bootstrap';
import {NavLink} from 'react-router-dom';
import '../App.css';


const Header = () =>{
	return(
		<>
		  <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark" sticky="top">
			  <Navbar.Brand style={{ marginTop: -8, color: '#11FC7F'}}>TRACKER</Navbar.Brand>
			  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
			  <Navbar.Collapse id="responsive-navbar-nav justify-content-end">
			    <Nav className="mr-auto">
			      <Nav.Link href="#"><NavLink to='/' className="nav-link my-link">Home</NavLink></Nav.Link>
			      <Nav.Link href="#"><NavLink to='/statewise' className="nav-link my-link">Cases</NavLink></Nav.Link>
			      <Nav.Link href="#"><NavLink to="/vaccination" className="nav-link my-link">Vaccination</NavLink></Nav.Link>
			      <Nav.Link href="#"><NavLink to="/about" className="nav-link my-link">About Us</NavLink></Nav.Link>
			    </Nav>
			  </Navbar.Collapse>
			</Navbar>
		</>
		);
}

export default Header;